import path from 'path';

import * as ENGINE from '@gnsx/genesys.js';

import type { AssetHandler } from '../../assetTypes';
import type { DropPayload } from '../../dragDropTypes';
import type { IAssetFile } from '../assetHandler';
import type * as THREE from 'three';

import { editorScene, store } from '@/editor/store';


export class JsClassHandler implements AssetHandler {
  private actor: ENGINE.Actor | null = null;

  private async addActor(asset: IAssetFile, worldPosition: THREE.Vector3): Promise<ENGINE.Actor | null> {
    const className = path.basename(asset.path);
    try {
      const actor = ENGINE.ClassRegistry.constructObject(className, {
        position: worldPosition,
      });

      editorScene.addObject(actor);

      console.log(`Spawned Actor ${actor.uuid} of class ${className} at ${worldPosition.toArray().join(', ')}`);
      return actor;
    } catch (error) {
      console.error(`Failed to spawn actor of class ${className}:`, error);
      return null;
    }
  }

  async handleSelect(asset: IAssetFile): Promise<void> {
    store.setSelectedAssetItem(asset);
  }

  async handleOpen(asset: IAssetFile): Promise<void> {
    await this.addActor(asset, editorScene.getCameraLookAtPosition());
  }

  async handleDragEnter(worldPosition: THREE.Vector3, payload: DropPayload): Promise<void> {
    console.log('handleDragEnter', payload);
    this.actor = await this.addActor(payload.payload, worldPosition);
  }

  async handleDrop(worldPosition: THREE.Vector3, payload: DropPayload): Promise<void> {
    this.actor = null;
  }

  async handleDragOver(worldPosition: THREE.Vector3, payload: DropPayload): Promise<void> {
    this.actor?.rootComponent.setWorldPosition(worldPosition);
    if (this.actor && this.actor === editorScene.selectedObject?.asActor) {
      editorScene.selectedObject.setDisplayPosition(worldPosition);
    }
  }

  async handleDragCancel(worldPosition: THREE.Vector3, payload: DropPayload): Promise<void> {
    editorScene.selectObject(null);
    this.actor?.destroy();
    editorScene.updateOutliner();
  }

  getTargetObject(): unknown {
    return this.actor;
  }
}


